import React from "react";
import { useSelector } from "react-redux";
import ChangeDateTimeModal from "../../../../components/ChangeDateTimeModal";
import ChangeLocationModal from "../../../../components/ChangeLocationModal";

import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import Alert from "../../../../assets/Alert.png";
import { TwPopover } from "../../../../components/tailwind";
import { useLocalStorage } from "../../../../hooks";
import { dashboardState } from "../../../../redux/reducers/dashboardReducer";
import { useTranslation } from "react-i18next";

export default function EditScheduleClassPopover({
  scheduleClassDetails,
  handleUpdate,
}) {
  const { t, i18n } = useTranslation();
  const [dateTimeModalOpen, setDateTimeModalOpen] = React.useState(false);
  const [locationModalOpen, setLocationModalOpen] = React.useState(false);
  const [userToken] = useLocalStorage("userToken");
  const dashboardReduxState = useSelector(dashboardState);

  const handleDateTimeModalOpen = () => {
    setDateTimeModalOpen(true)
    handleClose()
  }
  const handleDateTimeModalClose = () => setDateTimeModalOpen(false);

  const handleLocationModalOpen = () => {
    setLocationModalOpen(true)
    handleClose()
  }
  const handleLocationModalClose = () => setLocationModalOpen(false);

  const handleClose = () => {

  };

  const popoverOptions = [
    {
      text: t("myEvents.changeSchedule"),
      onClick: handleDateTimeModalOpen,
      disabled: false,
      icon: Alert,
    },
    {
      text: t("inputFieldsTitle.updateLocation"),
      onClick: handleLocationModalOpen,
      disabled: false,
      icon: Alert,
    },
  ];

  return (
    <div>
      <TwPopover
        buttonClassName={""}
        buttonContent={(<EllipsisVerticalIcon aria-hidden="true" className="size-5" />)}
      >
        <div className={"flex flex-col divide-y divide-gray-200"}>
          {popoverOptions.map((opt, idx) => (
            <button
              key={idx}
              disabled={opt.disabled}
              className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac`}
              onClick={opt.onClick}
            >
              {opt.text}
            </button>
          ))}
        </div>
      </TwPopover>

      <ChangeDateTimeModal
        open={dateTimeModalOpen}
        handleClose={handleDateTimeModalClose}
        sessionData={scheduleClassDetails}
        instanceId={scheduleClassDetails._id}
        handleUpdate={handleUpdate}
      />
      <ChangeLocationModal
        open={locationModalOpen}
        handleClose={handleLocationModalClose}
        sessionData={scheduleClassDetails}
        instanceId={scheduleClassDetails._id}
        handleUpdate={handleUpdate}
      />
    </div>
  );
}
